// Module
var code = `<div class="loan-preview">
  <div id="amortization" ng-if="\$ctrl.amortizationPreview">
    <table class="table">
      <thead>
      <tr>
        <th>No</th>
        <th>Due Date</th>
        <th>Principal</th>
        <th>Interests</th>
        <th ng-if="\$ctrl.shouldShowContractual()">CBU</th>
        <th ng-if="\$ctrl.shouldShowContractual()">PF</th>
        <th ng-if="\$ctrl.shouldShowContractual()">TP</th>
        <th ng-if="\$ctrl.shouldShowCustomFees()">Custom Fees</th>
        <th>Total</th>
        <th>Outstanding Balance</th>
      </tr>
      </thead>
      <tbody class="tbody">
      <tr ng-repeat="item in \$ctrl.amortizationPreview.list | limitTo: \$ctrl.config.maxAmortizationDisplayed">
        <td>{{item.lineNumber}}</td>
        <td>{{item.dueDate | prettyDateWithDay }}</td>
        <td>{{item.principalAmount | nxCurrency:'dashOnZero'}}</td>
        <td>{{item.interestAmount | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{item.cbuChargeAmount | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{item.pfChargeAmount | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{item.tpChargeAmount | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowCustomFees()">{{item.customFeesAmount | nxCurrency:'dashOnZero'}}</td>
        <td>{{item.amortizationAmount | nxCurrency:'dashOnZero'}}</td>
        <td>{{item.loanOutstandingBalance | nxCurrency:'dashOnZero'}}</td>
      </tr>
      <tr ng-if="\$ctrl.config.showSummary">
        <td><strong>Total:</strong></td>
        <td></td>
        <td>{{\$ctrl.amortizationPreview.totalAmount.principal | nxCurrency:'dashOnZero'}}</td>
        <td>{{\$ctrl.amortizationPreview.totalAmount.interest | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalAmount.cbuCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalAmount.pfCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalAmount.tpCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowCustomFees()">{{\$ctrl.amortizationPreview.totalAmount.customFees | nxCurrency:'dashOnZero'}}</td>
        <td>{{\$ctrl.amortizationPreview.totalAmount.total | nxCurrency:'dashOnZero'}}</td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.config.showSummary">
        <td><strong> Outstanding:</strong></td>
        <td></td>
        <td>{{\$ctrl.amortizationPreview.totalBalance.principal | nxCurrency:'dashOnZero'}}</td>
        <td>{{\$ctrl.amortizationPreview.totalBalance.interest | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalBalance.cbuCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalBalance.pfCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowContractual()">{{\$ctrl.amortizationPreview.totalBalance.tpCharge | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.shouldShowCustomFees()">{{\$ctrl.amortizationPreview.totalBalance.customFees | nxCurrency:'dashOnZero'}}</td>
        <td>{{\$ctrl.amortizationPreview.totalBalance.total | nxCurrency:'dashOnZero'}}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/preview/amortization-preview.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;